const COMPATIBLE = {
  single_number: new Set(['number', 'table']),
  trend: new Set(['line', 'bar', 'table', 'number']),
  compare: new Set(['bar', 'line', 'pie', 'table', 'number']),
  table: new Set(['table']),
};

export function isChartCompatible(questionType, vizType) {
  const allowed = COMPATIBLE[questionType] || new Set(['table']);
  return allowed.has(vizType);
}

export function resolveVizFromToggle(questionType, toggle) {
  if (toggle === 'number') return 'number';
  if (toggle === 'table') return 'table';
  if (toggle === 'pie') return 'pie';
  if (questionType === 'trend') return 'line';
  if (questionType === 'compare') return 'bar';
  return 'bar';
}

/**
 * Returns dynamic visualization options based on report spec & data.
 * - Trend: Line chart, Bar chart, Table
 * - Compare: Bar chart, Line chart, Table
 * - Number/Summary: Summary/Number, Table
 * - Table-only: Table (length 1 -> toggle will be hidden)
 */
export function getAvailableVisualizations(spec = {}, result = {}) {
  const questionType = spec?.question_type;
  const mode = spec?.visualization?.mode;

  // 1. Check if series data exists (time series or grouped bars)
  const hasSeries = Boolean(
    (Array.isArray(result?.categories) && result.categories.length && Array.isArray(result?.series) && result.series.length) ||
    (Array.isArray(result?.series) && result.series.length && Array.isArray(result.series[0]?.data) && result.series[0].data.length)
  );

  // 2. Check if metrics summary exists (e.g. Sent, Delivered, Read overview)
  const hasMetrics = Boolean(Array.isArray(result?.metrics) && result.metrics.length);

  // 3. Check if single number KPI
  const isSingleNumber = result?.kind === 'number' || questionType === 'single_number';

  if (hasSeries || questionType === 'trend' || questionType === 'compare' || mode === 'line' || mode === 'bar') {
    if (questionType === 'trend' || mode === 'line') {
      return [
        { id: 'line', label: 'Line chart', icon: 'line' },
        { id: 'bar', label: 'Bar chart', icon: 'bar' },
        { id: 'table', label: 'Table', icon: 'table' },
      ];
    }
    const compareOptions = [
      { id: 'bar', label: 'Bar chart', icon: 'bar' },
      { id: 'line', label: 'Line chart', icon: 'line' },
      { id: 'table', label: 'Table', icon: 'table' },
    ];
    if (mode === 'pie') {
      compareOptions.splice(2, 0, { id: 'pie', label: 'Pie chart', icon: 'pie' });
    }
    return compareOptions;
  }

  if (hasMetrics || isSingleNumber) {
    return [
      { id: 'number', label: hasMetrics ? 'Summary' : 'Number', icon: 'number' },
      { id: 'table', label: 'Table', icon: 'table' },
    ];
  }

  // Pure tabular report (e.g. Intervene Agent Performance table or records listing table)
  return [
    { id: 'table', label: 'Table', icon: 'table' },
  ];
}
